export const editarVendedor = 'EditarVendedores';
export const listarVendedores = 'ListarVendedores';
export const vendedores = [editarVendedor, listarVendedores];
